import { FC } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddPixel from "../screens/OnBoarding/AddPixel";

interface AddPixelModalProps {
  isOpen: boolean;
  onClose: () => void;
  createdWebId: string;
  onPixelVerified?: () => void;
}

const AddPixelModal: FC<AddPixelModalProps> = ({
  isOpen,
  onClose,
  createdWebId,
  onPixelVerified,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <AddPixel
          goToNext={() => {}}
          goToPrevious={() => {}}
          createdWebId={createdWebId}
          modalView={true}
          onPrimaryButtonClick={onClose}
          onPixelVerified={onPixelVerified}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AddPixelModal;